import { inject, Injectable } from '@angular/core';
import { SessionRepository } from '../../../../../shared/repositories/session.repository';
import { first, merge, Observable, Subject } from 'rxjs';
import { AddressDto } from '../../../../../api/v1/models/address-dto';
import { ConfigRepository } from '../../../../../shared/repositories/config.repository';
import { OutletDto } from '../../../../../api/v1/models/outlet-dto';
import { filter } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class AddressSelectorService {
  private sessionRepository = inject(SessionRepository);
  private configRepository = inject(ConfigRepository);

  private _deliveryAddress$: Subject<AddressDto | null> = new Subject<AddressDto | null>();
  private _selectedStore$: Subject<OutletDto | null> = new Subject<OutletDto | null>();

  selectedOutlet$ = merge(
    this.configRepository.activeOutlet$.pipe(first()),
    this._selectedStore$.asObservable(),
  );

  deliveryAddress$: Observable<AddressDto | null> = merge(
    this.sessionRepository.deliveryAddress$.pipe(
      filter(address => !!address),
      first()
    ),
    this._deliveryAddress$.asObservable(),
  );

  setDeliveryAddress(deliveryAddress: AddressDto): void {
    this._deliveryAddress$.next(deliveryAddress);
  }

  setSelectedStore(outlet: OutletDto | null): void {
    this._selectedStore$.next(outlet);
  }
}
